<div class="shipping-guide-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>Parcel Pro Shipping Guide-Rules and Restrictions</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <ng-container [ngTemplateOutlet]="rulesAndRegulations"></ng-container>
    </mat-dialog-content>
</div>

<ng-template #rulesAndRegulations>
    <div>
        <br/>
        <span class="pagetitle">Parcel Pro Shipping Guide-Rules and Restrictions</span>
        <div class='pageBar'></div>
        <br/> Please read and follow these instructions when insuring and shipping a package through Parcel Pro, Inc. services.
        These instructions, along with the terms and conditions, must be followed before a claim for loss or damage will
        be considered.
        <br/>
        <br/>
        <ol>
            <li>All packages must be double boxed and include the tracking number on the inner box. Make sure the inner box is
                <u>not</u> a small jewelry box that may be easily disposed. </li>
            <li>All packages must be properly packed and sealed to withstand the course of transit. </li>
            <li>All packages must be picked up at a shippers location, handed to a carrier staff driver or taken to a carrier
                staffed location. Do not use unmanned drop boxes. </li>
            <li>It is the shipper's responsibility to report their shipments to Parcel Pro, Inc., on the
                <u>same</u> day of shipping. Shipments without same day confirmation of receipt of report shall be treated as
                uninsured shipments. </li>
            <li>Reported packages with no declared value are considered not insured and have a maximum value of US$100.00. </li>
            <li>Never indicate anything on the air waybill or box that would suggest high value, such as the words jewelry, watch,
                diamond, pearl, gem, coin, bullion, oro, or known jewelry/watch retailers, brands or auction houses…or any
                abbreviations such as GIA, GTL, EGL, DIA, etc… </li>
            <li>Do not declare a value to the carrier unless instructed to do so by a Parcel Pro staff member. </li>
            <li>Your Daily Shipping Report and the values shipped are for your records only, and should never be given to the
                courier or shipped with the box. </li>
            <li>
                <b>THE SHIPPER INFORMATION:</b> On packages sent from New York zip codes 10036 and 10017 and Los Angeles zip
                codes, 90013, 90014, 90015, 90016, 90017, shipper must use an alternate address on the air waybill that is
                not one of these zip codes. You may use Parcel Pro Inc.'s office address. </li>
            <li>
                <b>ALL SHIPMENTS $10,000 OR MORE MUST BE CALLED IN FOR SPECIAL INSTRUCTIONS, UNLESS, OTHERWISE, AGREED TO IN
                    WRITING BY A PARCEL PRO, INC. REPRESENTATIVE.</b>
            </li>
            <li>
                <b>SHIPMENTS TO CERTAIN ZIP CODES REQUIRE YOU TO FOLLOW SPECIFIC PROCEDURES.</b>
                There may be additional restrictions to other zip codes that may apply, if so, Customers/Shipper must be notified. </li>
            <li>
                <b>SHIPMENTS TO NEW YORK :</b> Currently, all packages being sent to New York zip codes 10036 or 10017 with
                a value of US $5,000.00, call Parcel Pro, Inc. for instructions. </li>
            <li>
                <b>SHIPMENTS TO LOS ANGELES AND BEVERLY HILLS AREA :</b> Currently all packages being sent to Los Angeles zip
                codes, 90013, 90014, 90015, 90016, 90017, or to Beverly Hills Area 90048, 90209, 90210, 90211, 90211, 90212,
                90213, call Parcel Pro, Inc. for instructions. </li>
            <li>
                <b>SHIPMENTS TO TRADE SHOWS, APARTMENT COMPLEXES AND HOTELS :</b> Please call our office for special instructions
                on all packages going to the above locations. Note: All packages signed by any representative of the above
                listed or stated delivery locations being the recipient address are considered delivered and coverage terminates.
                Any claim due to loss, damage or missing content discovered after delivery to the above locations, will not
                be covered. </li>
            <li>
                <b>RELEASE SIGNATURE SHIPMENTS :</b> PACKAGES DELIVERED PER RELEASE SIGNATURE ARE CONSIDERED DELIVERED, AND
                COVERAGE TERMINATES. It is the shipper's responsibility to ensure that the recipient's address does not have
                a “Release Signature Status” with the courier, which allows packages to be dropped off unattended and unsigned.
            </li>
            <li>
                <b>RESIDENTIAL SHIPMENTS :</b> Delivery confirmation is based on information provided by the courier. SHIPMENTS
                LEFT AT A RESIDENCE UNSIGNED AND UNATTENDED ARE CONSIDERED AS VALID DELIVERIES; COVERAGE CEASES AT THE POINT
                OF DELIVERY. You should obtain an “Adult Signature Required” delivery at residences. Any claim due to loss,
                damage or missing content discovered after delivery to residences, will not be covered. </li>
            <li>
                <b>C.O.D. SHIPMENTS CAN BE INSURED; HOWEVER, C.O.D. PAYMENTS ARE NOT COVERED.</b>
            </li>
            <li>
                <b>DECLINING REQUEST FOR COVERAGE:</b> In order to ensure that its customers continue to enjoy the preferred
                insurance rate, Parcel Pro, Inc., in its sole and absolute discretion, may decline to request/confirm insurance
                be provided on certain shipments. </li>
            <li>
                <b>IMPORTANT NOTICE ON FRAUD:</b> The insurance policy issued to Parcel Pro, Inc. does not cover claims arising
                directly or indirectly from fraud/dishonesty/negligence, including, but not limited to, credit card fraud,
                check fraud, C.O.D. fraud, mail fraud or any fraud on behalf of the shipper/recipient or their employees.
            </li>
            <li>In addition to this, Parcel Pro's Shipping Guide-Rules and Restrictions are provided to the Customer/Shiper,
                plus Parcel Pro's Terms and Conditions and a Rate Sheet, which are part of the agreement between Parcel Pro,
                Inc., and its Customer/Shipper.</li>
            <li>No modification of the Parcel Pro Shipping Guide-Rules and Restrictions is permitted, and no Parcel Pro, Inc.
                employee at any time shall have authority to orally modify these shipping instructions. </li>
        </ol>

        <b>Form SGRR 072706 </b>

    </div>
</ng-template>